import { Link } from 'react-router-dom';
import moment from 'moment';

import styles from "../../../../styles/Admin.module.scss";

function Item(transaction) {
	const giftVoucher = transaction.giftVoucher?.code && transaction.giftVoucher?.code !== 'false'
	const isWalletTransaction = ['purchase', 'spend', 'refund', 'adjustment', 'membership_grant'].includes(transaction.type);
	const productLabel = transaction.Product?.description?.trim()
		? transaction.Product.description
		: transaction.Product
			? `${transaction.Product.credits} Token${transaction.Product.credits === 1 ? '' : 's'}`
			: null;
	const tokenTypeLabel = transaction.tokenType === 'open_gym'
		? 'Open gym'
		: transaction.tokenType === 'class'
			? 'Class'
			: 'General';
	const walletBookingLabel = transaction.ExperienceBooking?.reference
		? `Class booking ${transaction.ExperienceBooking.reference}`
		: transaction.Booking?._id
			? `Open gym booking`
			: transaction.ServiceBooking?.reference
				? `Appointment booking ${transaction.ServiceBooking.reference}`
				: null;

	if (isWalletTransaction) {
		return (
			<div className={styles.transaction}>
				<p>{moment(transaction.createdAt).fromNow()}</p>
				<p>{transaction.User?.firstName} {transaction.User?.lastName}</p>
				<p>
					{walletBookingLabel || transaction.MembershipPlan?.name || transaction.WalletPackage?.name || transaction.note || transaction.type}
					{' '}({tokenTypeLabel})
				</p>
				<p>{transaction.amount >= 0 ? '+' : ''}{transaction.amount} token{Math.abs(Number(transaction.amount || 0)) === 1 ? '' : 's'}</p>
			</div>
		)
	}

	return (
		<Link to={transaction._id} className={styles.transaction}>
			<p>{moment(transaction.createdAt).fromNow()}</p>
			<p>{giftVoucher && 'Gift Voucher'} {transaction.User?.firstName} {transaction.User?.lastName}</p>
			{transaction.Product ?
				<p>{productLabel}</p>
			:
				<p>{transaction.adjustment} {`Token${(transaction.adjustment < 1 || transaction.adjustment > -1) ? '' : 's'}`}</p>
			}
		</Link>
	)
}

export default Item;
